"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FAO_TEMPLATES = void 0;
const APPLICATION_REVIEW_TEMPLATE = [
    {
        type: 'p',
        children: [
            {
                text: 'AGENDA:',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(205, 75, 83)',
                underline: true,
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        children: [
            {
                text: 'Review of Application Components',
                fontSize: '10pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 2,
        children: [
            { text: 'Holistic Impressions', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 3,
        children: [
            { text: 'Setting a Game Plan', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 4,
        children: [{ text: 'Q&A', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    { type: 'p', children: [{ fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', text: '' }] },
    {
        type: 'p',
        children: [
            {
                text: 'NOTES:',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(205, 75, 83)',
                underline: true,
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        children: [
            {
                text: 'Application Status:',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        children: [
            { text: 'School for Review: ', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
            {
                text: '[School name]',
                fontSize: '10pt',
                backgroundColor: 'transparent',
                color: 'rgb(205, 75, 83)',
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 2,
        children: [
            {
                text: 'Application Status: [Complete / Near Complete / Far from Complete]',
                fontSize: '10pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [
            { text: 'Student’s Evaluation: ', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
        ],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [
            {
                text: 'In today’s meeting, you and your FAO will evaluate each section of the application individually, making suggested edits along the way, and then sharing broad impressions holistically.',
                fontSize: '10pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'square',
        indent: 3,
        children: [
            {
                text: 'NOTE: Remember, your FAO’s input is informed by professional experience but is ultimately speculative; other AOs may see this differently.',
                fontSize: '9pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
                italic: true,
            },
        ],
    },
    {
        type: 'p',
        children: [{ fontSize: '9pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', italic: true, text: '' }],
    },
    {
        type: 'p',
        children: [
            {
                text: 'Individual Section Review/Suggested Edits',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        children: [
            { text: 'Academics & Testing', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
        ],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Suggested Edit 1: ', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Suggested Edit 2:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 2,
        children: [{ text: 'Extracurriculars', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Suggested Edit 1: ', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Suggested Edit 2:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 3,
        children: [{ text: 'Personal Statement', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Suggested Edit 1:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Suggested Edit 2:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 4,
        children: [
            { text: 'Supplemental Essays', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
        ],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Suggested Edit 1:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Suggested Edit 2: ', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 5,
        children: [
            { text: 'Additional Information', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
        ],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Suggested Edit 1', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Suggested Edit 2: ', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    { type: 'p', children: [{ fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', text: '' }] },
    {
        type: 'p',
        children: [
            {
                text: 'Holistic Impressions of Strengths and Weaknesses of App',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        children: [
            { text: 'Bottom-line Summary: ', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 2,
        children: [{ text: 'Strengths', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Strength 1: ', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Strength 2: ', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 3,
        children: [{ text: 'Weaknesses', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Weakness 1: ', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Weakness 2: ', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    { children: [{ text: '' }], type: 'p' },
    {
        type: 'p',
        children: [
            {
                text: 'Additional Recommendations (if any)',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        children: [{ text: 'Recommendation 1: ', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 2,
        children: [{ text: 'Recommendation 2: ', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    { children: [{ text: '' }], type: 'p' },
    {
        type: 'p',
        children: [{ text: 'Q&A', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        children: [{ text: 'Question:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Answer:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(205, 75, 83)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 2,
        children: [{ text: 'Question:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Answer:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(205, 75, 83)' }],
    },
    { children: [{ text: '' }], type: 'p' },
    {
        type: 'p',
        children: [
            {
                text: 'Next Session Date: ',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
                bold: true,
            },
            {
                text: '[Confirmed date/time or suggested time, if applicable]',
                fontSize: '10pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
            },
        ],
    },
    { type: 'p', children: [{ text: '' }] },
];
const SCHOOL_LIST_ASSESSMENT_TEMPLATE = [
    {
        type: 'p',
        children: [
            {
                text: 'AGENDA:',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(205, 75, 83)',
                underline: true,
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        children: [
            { text: 'Review of Student’s Profile', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 2,
        children: [
            { text: 'Assessment of School List', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 3,
        children: [
            { text: 'Admissions Officer Feedback', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 4,
        children: [{ text: 'Q&A', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    { type: 'p', children: [{ fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', text: '' }] },
    {
        type: 'p',
        children: [
            {
                text: 'NOTES:',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(205, 75, 83)',
                underline: true,
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        children: [
            {
                text: 'Student’s School List:',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        children: [
            { text: 'HARD REACH', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(205, 75, 83)', bold: true },
        ],
        indent: 1,
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        children: [{ text: 'School #1:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        listStart: 2,
        children: [{ text: 'School #2:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        listStart: 3,
        children: [{ text: 'School #3:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        children: [
            { text: 'REACH', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(205, 75, 83)', bold: true },
        ],
        indent: 1,
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        children: [{ text: 'School #4:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        listStart: 2,
        children: [{ text: 'School #5:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        listStart: 3,
        children: [{ text: 'School #6:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        children: [
            { text: 'TARGET', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(205, 75, 83)', bold: true },
        ],
        indent: 1,
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        children: [{ text: 'School #7:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        listStart: 2,
        children: [{ text: 'School #8:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        listStart: 3,
        children: [{ text: 'School #9:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        children: [
            { fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(205, 75, 83)', bold: true, text: 'SAFETY' },
        ],
        indent: 1,
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        children: [{ text: 'School #10:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        listStart: 2,
        children: [{ text: 'School #11:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        listStart: 3,
        children: [{ text: 'School #12:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    { type: 'p', children: [{ fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', text: '' }] },
    {
        type: 'p',
        children: [
            {
                text: 'Admissions Officer Assessment',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        children: [
            {
                text: 'Schools your Admissions Officer most ',
                fontSize: '10pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
            },
            { text: 'agrees', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
            { text: ' with:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
        ],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'School 1:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'square',
        indent: 3,
        children: [{ text: 'Why:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'School 2:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'square',
        indent: 3,
        children: [{ text: 'Why:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 3,
        children: [{ text: 'School 3:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'square',
        indent: 3,
        children: [{ text: 'Why:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 2,
        children: [
            {
                text: 'Schools your Admissions Officer most ',
                fontSize: '10pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
            },
            { text: 'disagrees', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true },
            { text: ' with:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
        ],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'School 1:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'square',
        indent: 3,
        children: [{ text: 'Why:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'School 2:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'square',
        indent: 3,
        children: [{ text: 'Why:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 3,
        children: [{ text: 'School 3:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'square',
        indent: 3,
        children: [{ text: 'Why:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    { type: 'p', children: [{ fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', text: '' }] },
    {
        type: 'p',
        children: [
            {
                text: 'Admissions Officer’s Recommended School List:',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        indent: 1,
        children: [
            { text: 'HARD REACH', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(205, 75, 83)', bold: true },
        ],
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        children: [{ text: 'School #1:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        listStart: 2,
        children: [{ text: 'School #2:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        listStart: 3,
        children: [{ text: 'School #3:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        indent: 1,
        children: [
            { text: 'REACH', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(205, 75, 83)', bold: true },
        ],
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        children: [{ text: 'School #4:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        listStart: 2,
        children: [{ text: 'School #5:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        listStart: 3,
        children: [{ text: 'School #6:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        children: [
            { text: 'TARGET', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(205, 75, 83)', bold: true },
        ],
        indent: 1,
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        children: [{ text: 'School #7:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        listStart: 2,
        children: [{ text: 'School #8:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        listStart: 3,
        children: [{ text: 'School #9:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        children: [
            { text: 'SAFETY', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(205, 75, 83)', bold: true },
        ],
        indent: 1,
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        children: [{ text: 'School #10:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        listStart: 2,
        children: [{ text: 'School #11:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'decimal',
        indent: 1,
        listStart: 3,
        children: [{ text: 'School #12:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    { children: [{ text: '' }], type: 'p' },
    {
        type: 'p',
        children: [
            {
                text: 'Additional Recommendations (if any):',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        children: [{ text: 'Recommendation 1: ', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 2,
        children: [{ text: 'Recommendation 2: ', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 3,
        children: [
            { text: 'Recommendation 3:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
            { text: '\n' },
        ],
    },
    {
        type: 'p',
        children: [{ text: 'Q&A', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        children: [{ text: 'Question:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Answer:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(205, 75, 83)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 2,
        children: [{ text: 'Question:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Answer:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(205, 75, 83)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 3,
        children: [{ text: 'Question:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Answer::', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(205, 75, 83)' }],
    },
    { children: [{ text: '' }], type: 'p' },
    {
        type: 'p',
        children: [
            {
                text: 'Next Session Date: ',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
                bold: true,
            },
            {
                text: '[Confirmed date/time or suggested time, if applicable]',
                fontSize: '10pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
            },
        ],
    },
    { type: 'p', children: [{ text: '' }] },
];
const ESSAY_ASSESSMENT_TEMPLATE = [
    {
        type: 'p',
        children: [
            {
                text: 'AGENDA:',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(205, 75, 83)',
                underline: true,
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        children: [
            {
                text: 'Personal Statement Assessment',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 2,
        children: [
            {
                text: 'Supplemental Essay Assessment',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 3,
        children: [{ text: 'Q&A', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    { type: 'p', children: [{ fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', text: '' }] },
    {
        type: 'p',
        children: [
            {
                text: 'NOTES:',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(205, 75, 83)',
                underline: true,
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        children: [
            {
                text: 'Personal Statement Assessment',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        children: [
            { text: 'Overall Assessment:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
        ],
    },
    { type: 'p', children: [{ text: '' }], indent: 2, listStyleType: 'circle' },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        children: [{ text: 'Strengths', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
        listStart: 2,
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Strength #1:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Strength #2:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 3,
        children: [{ text: 'Strength #3:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 3,
        children: [{ text: 'Weaknesses', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Weakness #1:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Weakness #2:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 3,
        children: [{ text: 'Weakness #3:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 4,
        children: [{ text: 'Recommendations:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Recommendation #1:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Recommendation #2:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 3,
        children: [{ text: 'Recommendation #3:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    { children: [{ text: '' }], type: 'p' },
    {
        type: 'p',
        children: [
            {
                text: 'Supplemental Essay Assessments',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
                bold: true,
            },
        ],
    },
    { children: [{ text: '\n' }], type: 'p' },
    {
        type: 'p',
        children: [
            {
                text: 'Supplemental Essay #1',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        children: [
            { text: 'Overall Assessment:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
        ],
    },
    { type: 'p', listStyleType: 'circle', indent: 2, children: [{ text: '' }] },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 2,
        children: [{ text: 'Strengths', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Strength #1:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Strength #2:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 3,
        children: [{ text: 'Weaknesses', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Weakness #1:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Weakness #2:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 4,
        children: [{ text: 'Recommendations:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Recommendation #1:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Recommendation #2:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    { children: [{ text: '' }], type: 'p' },
    {
        type: 'p',
        children: [
            {
                text: 'Supplemental Essay #2',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        children: [
            { text: 'Overall Assessment:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
        ],
    },
    { type: 'p', listStyleType: 'circle', indent: 2, children: [{ text: '' }] },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 2,
        children: [{ text: 'Strengths', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Strength #1:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Strength #2:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 3,
        children: [{ text: 'Weaknesses', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Weakness #1:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Weakness #2:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 4,
        children: [{ text: 'Recommendations:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Recommendation #1:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Recommendation #2:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    { children: [{ text: '' }], type: 'p' },
    {
        type: 'p',
        children: [
            {
                text: 'Supplemental Essay #3',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        children: [
            { text: 'Overall Assessment:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
        ],
    },
    { type: 'p', listStyleType: 'circle', indent: 2, children: [{ text: '' }] },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 2,
        children: [{ text: 'Strengths', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Strength #1:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Strength #2:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 3,
        children: [{ text: 'Weaknesses', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Weakness #1:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Weakness #2:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 4,
        children: [{ text: 'Recommendations:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Recommendation #1:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Recommendation #2:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    { children: [{ text: '' }], type: 'p' },
    {
        type: 'p',
        children: [
            {
                text: 'Supplemental Essay #4 (if applicable)',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        children: [
            { text: 'Overall Assessment:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
        ],
    },
    { type: 'p', listStyleType: 'circle', indent: 2, children: [{ text: '' }] },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 2,
        children: [{ text: 'Strengths', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Strength #1:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Strength #2:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 3,
        children: [{ text: 'Weaknesses', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Weakness #1:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Weakness #2:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 4,
        children: [{ text: 'Recommendations:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Recommendation #1:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Recommendation #2:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    { children: [{ text: '' }], type: 'p' },
    {
        type: 'p',
        children: [
            {
                text: 'Supplemental Essay #5 (if applicable)',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
                bold: true,
            },
        ],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        children: [
            { text: 'Overall Assessment:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
        ],
    },
    { type: 'p', listStyleType: 'circle', indent: 2, children: [{ text: '' }] },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 2,
        children: [{ text: 'Strengths', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Strength #1:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Strength #2:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 3,
        children: [{ text: 'Weaknesses', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Weakness #1:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [{ text: 'Weakness #2:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 4,
        children: [{ text: 'Recommendations:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Recommendation #1:', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        listStart: 2,
        children: [
            { text: 'Recommendation #2::', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' },
        ],
    },
    { children: [{ text: '' }], type: 'p' },
    {
        type: 'p',
        children: [{ text: 'Q&A', fontSize: '11pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)', bold: true }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        children: [{ text: 'Question:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Answer:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(205, 75, 83)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 2,
        children: [{ text: 'Question:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Answer:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(205, 75, 83)' }],
    },
    {
        type: 'p',
        listStyleType: 'disc',
        indent: 1,
        listStart: 3,
        children: [{ text: 'Question:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(0, 0, 0)' }],
    },
    {
        type: 'p',
        listStyleType: 'circle',
        indent: 2,
        children: [{ text: 'Answer:', fontSize: '10pt', backgroundColor: 'transparent', color: 'rgb(205, 75, 83)' }],
    },
    {
        children: [
            { text: '\n' },
            {
                text: 'Next Session Date: ',
                fontSize: '11pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
                bold: true,
            },
            {
                text: '[Insert confirmed date/time or suggested time, if applicable]',
                fontSize: '10pt',
                backgroundColor: 'transparent',
                color: 'rgb(0, 0, 0)',
            },
        ],
        type: 'p',
    },
    { type: 'p', children: [{ text: '' }] },
];
exports.FAO_TEMPLATES = {
    'Initial Admissions Officer Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [{ text: 'N/A' }],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Grade 9 Assessment': [
        {
            listStart: 1,
            type: 'p',
            children: [{ text: 'N/A' }],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Think like an Admissions Officer': [
        {
            listStart: 1,
            type: 'p',
            children: [{ text: 'N/A' }],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Activities Unlocked': [
        {
            listStart: 1,
            type: 'p',
            children: [{ text: 'N/A' }],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Grade 10 Assessment': [
        {
            listStart: 1,
            type: 'p',
            children: [{ text: 'N/A' }],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Mock Activities List Workshop': [
        {
            listStart: 1,
            type: 'p',
            children: [{ text: 'N/A' }],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Activities Intensification': [
        {
            listStart: 1,
            type: 'p',
            children: [{ text: 'N/A' }],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Grade 11 Assessment': [
        {
            listStart: 1,
            type: 'p',
            children: [{ text: 'N/A' }],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Hook Statement Workshop': [
        {
            listStart: 1,
            type: 'p',
            children: [{ text: 'N/A' }],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'School List Assessment': SCHOOL_LIST_ASSESSMENT_TEMPLATE,
    'Essay Assessment': ESSAY_ASSESSMENT_TEMPLATE,
    'ED/EA Application Review': APPLICATION_REVIEW_TEMPLATE,
    'UC Application Review': APPLICATION_REVIEW_TEMPLATE,
    'RD Application Review': APPLICATION_REVIEW_TEMPLATE,
    Other: [
        {
            listStart: 1,
            type: 'p',
            children: [{ text: 'N/A' }],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
};
//# sourceMappingURL=fao.js.map